import styled, { css } from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';
import { colorExtraLight } from '@client/styles/styled-components/variables';
import { Spacer } from '@lux/tokens';

export const OuterWrapper = styled.div<{
    isM1Rebranding: boolean;
}>`
    ${({ isM1Rebranding }) =>
        isM1Rebranding
            ? `
        margin-bottom: ${Spacer.S};
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-bottom: 24px;
        }`
            : `
        margin-bottom: 75px;
        margin-top: 0;
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-bottom: 90px;
            margin-top: 0;
        }
    `}
`;

export const AlertBannerWrapper = styled.div`
    position: absolute;
    width: 100%;
    z-index: 30;
`;

export const Wrapper = styled.div<{ isThbResizeVariant: boolean }>`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: ${({ isThbResizeVariant }) => (isThbResizeVariant ? '300px' : '400px')};

    ${screenBiggerThan(Screen.smallTablet)} {
        height: 335px;
    }
    ${screenBiggerThan(Screen.tablet)} {
        height: 500px;
    }
`;

interface TabsWrapperProps {
    readonly floating: boolean;
    readonly floatingHidden: boolean;
    readonly smartbannerVisibility: boolean;
}

export const CommercialWrapper = styled.div<{ floating: boolean; floatingHidden: boolean }>`
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 101;
    transition: top 0.15s linear;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

    ${screenBiggerThan(Screen.smallTablet)} {
        top: 75px;
    }

    ${({ floating, floatingHidden }) =>
        floating &&
        css`
            top: ${floatingHidden ? 60 : 110}px;
            z-index: 1001;

            ${screenBiggerThan(Screen.smallTablet)} {
                margin-top: 0;
                top: ${floatingHidden ? 75 : 125}px;
            }
        `}

    &.commercial-transition-enter, &.commercial-transition-exit {
        z-index: 101;
        transition: top 0.15s linear, transform 0.3s ease-out;
    }

    &.commercial-transition-enter {
        transform: translateY(-100%);
    }

    &.commercial-transition-enter-active,
    &.commercial-transition-enter-done {
        transform: translateY(0);
    }

    &.commercial-transition-exit,
    &.commercial-transition-exit-done {
        transform: translateY(-100%);
    }
`;

export const TabsWrapper = styled.div<TabsWrapperProps>`
    width: 100%;
    position: absolute;
    transition: top 0.25s linear;
    overflow: hidden;
    height: 50px;
    background-color: ${colorExtraLight};
    margin: 15px 0 10px;

    ${screenBiggerThan(Screen.smallTablet)} {
        margin: 20px 0;
    }

    ${({ floating, smartbannerVisibility }) =>
        floating &&
        `
        position: fixed;
        z-index: 1000;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        top: ${smartbannerVisibility ? 120 : 60}px;
        margin-top: 0;
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-top: 0;
            top: ${smartbannerVisibility ? 135 : 75}px;
        }
    `}

    ${({ floatingHidden }) =>
        floatingHidden &&
        `
        top: 10px;
        box-shadow: none;
        ${screenBiggerThan(Screen.smallTablet)} {
            top: 25px;
        }
    `}
`;

export const SpinnerWrapper = styled.div`
    width: 100%;
    margin: 60px auto 30px;
    display: flex;
    justify-content: center;

    ${screenBiggerThan(Screen.smallTablet)} {
        margin-top: 75px;
    }
`;
